import {userConstants} from '../../_constants';

export function citiesByDeliveryType(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_CITY_BY_DELIVERY_TYPE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.GET_CITY_BY_DELIVERY_TYPE_SUCCESS:
      return {
        loading: false,
        // typeDelivery: action.data,
        ...action.data,
      };
    case userConstants.GET_CITY_BY_DELIVERY_TYPE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
